import {Device} from '../backend/interfaces/device';

export class QuickAccessData {
  serialNumber!: string;
  authenticationKey!: string;
  device!: Device;

  userIds?: Array<string>;

  constructor(init?: Partial<QuickAccessData>) {
    Object.assign(this, init);
  }
}
